module.exports = __webpack_public_path__ + "static/img/share_common.c35091a7.png";